import AxiosClient from '../../../services/axios.services';

class UnidadNodeServices {
  getUnidadNode = id => AxiosClient.get('/api/app/Funciona_listado_hijos_nohijos_unidad/', {
    headers: {'Content-Type': 'application/json'},
    params: {unidad: id}
  });

  saveUnidadNode = data => AxiosClient.post('/api/app/Funcionas_unidad_agregar_hijos/', data, {
    headers: {'Content-Type': 'application/json'}
  });

  deleteUnidadNodew = data => AxiosClient.post(`/api/app/Funcionas_unidad_quitar_hijos/`, data, {
    headers: {'Content-Type': 'application/json'}
  });  
}

export default new UnidadNodeServices();